<template>
  <MKIcons class="bg-icon rounded-full mr-3-5 w-10 h-10 text-white text-xs"
           :class="iconClass"
           :style="iconStyle"
           :icon="icon"/>
</template>

<script>
import MKIcons from "@/components/icons/MKIcons/MKIcons";

export default {
  name: "AccountIcon",
  components: {MKIcons},
  props: {
    icon: {
      type: String,
      required: true
    },
    iconClass: {
      type: String
    },
    iconColor: String,
    iconBg: String
  },
  computed: {
    iconStyle() {
      let computedStyle = ''
      if (this.iconColor) computedStyle += `color:${this.iconColor};`
      if (this.iconBg) computedStyle += `background:${this.iconBg};`
      return computedStyle
    }
  }
}
</script>

<style scoped>

</style>